import { ColumnSource, RequestFilters, RowSource } from "@omegagrid/grid";
import { ColorTypes } from "@omegagrid/core";
import { msg } from "@omegagrid/localize";
import rp, { GridEditorAdapter, GridEditorOptions, RowData } from "@reporting/rp-app-host";
import { FiscalYear } from "@reporting/rp-types/definition";

const PAGE_SIZE = 500;

export class FiscalYearGridEditorAdapter extends GridEditorAdapter {

	private _columns: ColumnSource[];

	async getColumns(): Promise<ColumnSource[]> {
		if (this._columns) return this._columns;
		this._columns = [{
			t: 'a',
			e: false,
			w: 5 + 20 * 2,
			content: [{
				action: 'delete',
				title: msg('Delete'),
				icon: 'trash',
				color: ColorTypes.Red
			}, {
				action: 'duplicate',
				title: msg('Duplicate'),
				icon: 'copy',
				color: ColorTypes.Yellow
			}],
			filter: false,
			sorting: false,
		}, {
			data: 'year',
			header: msg('Year'),
			t: 'n',
			z: '0',
			e: true,
			w: 130
		}, {
			data: 'year_offset',
			header: `${msg('Year')} - ${msg('Offset')}`,
			t: 'n',
			z: '0',
			e: true,
			w: 130
		}, {
			data: 'month_offset',
			header: `${msg('Month')} - ${msg('Offset')}`,
			t: 'n',
			z: '0',
			e: true,
			w: 130
		}, {
			data: 'month_count',
			header: `${msg('Month')} - ${msg('Count')}`,
			t: 'n',
			z: '0',
			e: true,
			w: 130
		}, {
			data: 'idz',
			t: 'n',
			hidden: true,
			e: false,
		}];
		return this._columns;
	}

	async getRows(filters?: RequestFilters): Promise<RowSource[]> {
		const fiscalYears = await rp.ms('definition').get<FiscalYear[]>('fiscalYears', this.createRequestParams(filters, {
			fields: ['idz', 'year', 'year_offset', 'month_offset', 'month_count'],
			count: PAGE_SIZE
		}));
		return fiscalYears.map(data => ({ data }));
	}

	getOptions(): Partial<GridEditorOptions> {
		return this.createOptions({
			colLetters: false,
			columnSorting: true,
			filters: true,
			pageSize: PAGE_SIZE,
			refreshAfterSave: true,
			rowMenu: {
				addRows: true,
				deleteRows: true,
			},
		});
	}

	async save(rowData: RowData[]) {
		const data = rowData.map(row => Object.assign({_state: row.state, _index: row.index}, row.data));
		await rp.ms('definition').post('fiscalYears', data);
	}

}
